export interface SocialShareLinks {
  twitter: string;
  bluesky: string;
  sms: string;
  reddit: string;
  whatsapp: string;
  facebook: string;
}

export function buildSocialShareLinks(url: string, text: string): SocialShareLinks {
  const encodedUrl = encodeURIComponent(url);
  const encodedText = encodeURIComponent(text);
  const encodedMessage = encodeURIComponent(`${text}\n${url}`);

  return {
    twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
    bluesky: `https://bsky.app/intent/compose?text=${encodedMessage}`,
    sms: `sms:?body=${encodedMessage}`,
    reddit: `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedText}`,
    whatsapp: `https://wa.me/?text=${encodedMessage}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
  };
}
